import { render, staticRenderFns } from "./tdUserNameLink.vue?vue&type=template&id=34d8c031&scoped=true"
import script from "./tdUserNameLink.vue?vue&type=script&lang=js"
export * from "./tdUserNameLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d8c031",
  null
  
)

export default component.exports